/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import {
  Grid,
  TextField,
  Autocomplete,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TuneIcon from "@mui/icons-material/Tune";
import ClearIcon from "@mui/icons-material/Clear";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Vocabulary } from "../../Utils/Vocabulary";
import { isMobile } from "../../Utils/utils";
import { europeanDate } from "../../Utils/formatDate";
import moment, { Moment } from "moment";

export type DocumentFilters = {
  status: number;
  page: number;
  perPage: number;
  search: string | null;
  startDate: string | null;
  endDate: string | null;
  documentType: string | null;
};

interface DocumentsFiltersProps {
  filters: DocumentFilters;
  onFilterChange: (filterName: string, value: any) => void;
  onResetFilters?: () => void;
  documentTypes: string[];
}

const DocumentsFilters: React.FC<DocumentsFiltersProps> = ({
  filters,
  onFilterChange,
  onResetFilters,
  documentTypes,
}) => {
  const [accordeonState, setAccordeonState] = useState(true);


  const handleDateChange = (field: string, date: Moment | null) => {
    onFilterChange(field, date ? date.format("YYYY-MM-DD") : null);
  };

  const handleTypeChange = (_: any, newValue: any) => {
    onFilterChange("documentType", newValue|| null);
  };

  const handleResetFilters = () => {
    if (onResetFilters) {
      onResetFilters();
    } else {
      onFilterChange("search", null);
      onFilterChange("startDate", null);
      onFilterChange("endDate", null);
      onFilterChange("documentType", null);
    }
  };

  const selectedDocumentType = documentTypes.find(
    (type) => type ===  filters.documentType
  );

  return (
    <Accordion
      onChange={() => {
        setAccordeonState(!accordeonState);
      }}
      expanded={accordeonState}
      style={{ marginBottom: 20 }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <TuneIcon style={{ marginRight: 10 }} />
        <Typography style={{ marginTop: 1, fontSize: "1rem" }}>
          Filtre
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid
          container
          spacing={isMobile() ? 2 : 6}
          style={{ marginBottom: 10 }}
        >
          <Grid item xs={6} md={6} lg={3} style={{ maxWidth: "100%" }}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DesktopDatePicker
                format={europeanDate}
                label={Vocabulary.startDate}
                value={filters.startDate ? moment(filters.startDate) : null}
                maxDate={filters.endDate ? moment(filters.endDate) : undefined}
                onChange={(date) => handleDateChange("startDate", date)}
                slotProps={{ 
                  textField: { size: "small", fullWidth: true },
                  actionBar: { actions: ['clear'] }
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={6} md={6} lg={3}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DesktopDatePicker
                format={europeanDate}
                label={Vocabulary.endDate}
                value={filters.endDate ? moment(filters.endDate) : null}
                minDate={
                  filters.startDate ? moment(filters.startDate) : undefined
                }
                onChange={(date) => handleDateChange("endDate", date)}
                slotProps={{ 
                  textField: { size: "small", fullWidth: true },
                  actionBar: { actions: ['clear'] }
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <Autocomplete
              options={documentTypes}
              getOptionLabel={(option: any) => option}
              value={selectedDocumentType || null}
              freeSolo={false}
              selectOnFocus
              handleHomeEndKeys
              clearOnEscape
              disableClearable={false}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={Vocabulary.documentType || "Document Type"}
                  size="small"
                />
              )}
              onChange={handleTypeChange}
            />
          </Grid>
        </Grid>
        <div style={{ marginTop: 15, textAlign: "right", }}>
          <Button
            variant="outlined"
            size="small"
            onClick={handleResetFilters}
            startIcon={<ClearIcon />}
            style={{
              color:"#FF6633",
              borderColor: "#FF6633",
            }}
          >
            {Vocabulary.resetFilters}
          </Button>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default DocumentsFilters;
